// extracted by mini-css-extract-plugin
export default {"container":"Home_container__w+u63","osIconBtn":"Home_osIconBtn__4RxGp","osIconList":"Home_osIconList__0o+ou","waveImage":"Home_waveImage__qNTCZ","searchBar":"Home_searchBar__m9WRh"};